var exports = {
  "f": "DisplayTab.module__sectionContent___N0NPRS",
  "j": "DisplayTab.module__radioSection___N0NPRS",
};

module.exports = exports;
